import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HTTP_UNAUTHORIZED = 401;
const SESSION_KEY = "dcn_session";

export const sessionMarker = {
  set: () => localStorage.setItem(SESSION_KEY, "1"),
  clear: () => localStorage.removeItem(SESSION_KEY),
  exists: () => localStorage.getItem(SESSION_KEY) === "1",
};

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    if (status === HTTP_UNAUTHORIZED && !original._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login") && sessionMarker.exists()) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (refreshErr) {
        refreshPromise = null;
        sessionMarker.clear();
        if (!url.includes("/auth/me") && window.location.pathname !== "/login") {
          window.location.assign("/login");
        }
      }
    }
    return Promise.reject(error);
  }
);

export function errText(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
